import { PrintParamsData } from '../print.interface';

export class PrintParams {
  private _params: PrintParamsData;

  public get(key: string) { return this._params ? this._params[key] : null; }

  public set params(params: PrintParamsData) { this._params = params; }
  public get params(): PrintParamsData { return this._params; }
}
